import { ref, onUnmounted, onMounted } from 'vue';
import { Button } from '@yellowcard/components-library-vue3';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import { formatDate } from '@/utils/helpers';
import router from '@/router';
import { TransactTypes } from '@/types/transact';
import { usePaymentStore } from '@/store/modules/payment';
export default {
    name: 'SellPendingDeposit',
    components: {
        Button,
    },
    setup() {
        const currentOrderStatus = ref(1);
        const transactionStore = useTransactionsStore();
        const { fetchPayment } = transactionStore;
        const { payment, currentStep } = storeToRefs(transactionStore);
        const paymentStore = usePaymentStore();
        const authStore = useAuthStore();
        const { user } = storeToRefs(authStore);
        let intervalId;
        const setPaymentStatus = () => {
            const { Status } = WidgetApiServiceTypes;
            switch (payment.value?.status) {
                case Status.CREATED:
                case Status.PENDING_SETTLEMENT:
                    currentOrderStatus.value = 1;
                    break;
                case Status.PENDING_CONFIRMATION:
                    currentOrderStatus.value = 2;
                    break;
                case Status.PROCESSING:
                    currentOrderStatus.value = 3;
                    break;
                case Status.COMPLETE:
                    currentOrderStatus.value = 4;
                    break;
                default:
                    currentOrderStatus.value = 1;
            }
        };
        const goToMyAccount = () => {
            transactionStore.resetStore();
            paymentStore.resetStore();
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        onMounted(() => {
            setPaymentStatus();
            intervalId = window.setInterval(async () => {
                await fetchPayment();
                setPaymentStatus();
            }, 10000);
        });
        onUnmounted(() => {
            clearInterval(intervalId);
        });
        return {
            currentOrderStatus,
            payment,
            formatDate,
            user,
            goToMyAccount,
        };
    },
};
